export const enableFundingModal = () => {
  const modalTriggers = document.querySelectorAll('.js-open-funding[data-open="funding-legals"]');
  modalTriggers.forEach((modalTrigger) => {
    modalTrigger.addEventListener('click', function() {
      const revealContent = document.querySelector('#funding-legals .reveal__content');
      const fundingInfo = modalTrigger.querySelector('.js-funding_info');
      revealContent.innerHTML = fundingInfo.innerHTML;
    });
  });

  const showFundingText = document.querySelector('.js-show-funding-text');
  if (showFundingText) {
    const fundingText = document.querySelector('.js-funding-text');
    if (fundingText) fundingText.style.display = 'block';
  }
}

enableFundingModal();

